<div class="invoice-contact-card" *ngIf="invoiceData">
  <div class="invoice-contact-info">
    <div class="invoice-contact-name">{{ invoiceData.supplierName }}</div>
    <div class="invoice-contact-reference">{{ invoiceData.invoiceNumber }}</div>
  </div>
  <div class="invoice-amount">{{ invoiceData.amountDue | currency }}</div>
</div>
